export default (props) => (
  /**
   * Ícone escala da cores degradê verde.
   * Utilizada no dropdown "Escala de cores"
   * na edição de simbologia.
   */
  <svg
    width="176"
    height="22"
    viewBox="0 0 176 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.447266 3.00781C0.447266 1.35096 1.79041 0.0078125 3.44727 0.0078125H17.9643V21.4193H3.44727C1.79041 21.4193 0.447266 20.0762 0.447266 18.4193V3.00781Z"
      fill="#005E11"
    />
    <path
      d="M175.618 18.4219C175.618 20.0787 174.275 21.4219 172.618 21.4219L158.101 21.4219L158.101 0.0103619L172.618 0.0103625C174.275 0.0103626 175.618 1.35351 175.618 3.01036L175.618 18.4219Z"
      fill="#F0F8E9"
    />
    <path
      d="M17.9648 0.0078125H35.4819V21.4193H17.9648V0.0078125Z"
      fill="#027C29"
    />
    <path
      d="M35.4814 0.0078125H52.9985V21.4193H35.4814V0.0078125Z"
      fill="#008F33"
    />
    <path
      d="M52.9985 0.0078125H70.5156V21.4193H52.9985V0.0078125Z"
      fill="#01A13D"
    />
    <path
      d="M70.5151 0.0078125H88.0322V21.4193H70.5151V0.0078125Z"
      fill="#00B147"
    />
    <path
      d="M88.0327 0.0078125H105.55V21.4193H88.0327V0.0078125Z"
      fill="#00BC65"
    />
    <path
      d="M105.55 0.0078125H123.067V21.4193H105.55V0.0078125Z"
      fill="#51C982"
    />
    <path
      d="M123.066 0.0078125H140.583V21.4193H123.066V0.0078125Z"
      fill="#BAE2A3"
    />
    <path
      d="M140.584 0.0078125H158.101V21.4193H140.584V0.0078125Z"
      fill="#D5EFC7"
    />
  </svg>
);
